import React from 'react'
export const BackendContext = React.createContext(false)
